import { Injectable, inject } from '@angular/core';

import { ConfirmationService } from '@abp/ng.theme.shared';

@Injectable({
  providedIn: 'root',
})
export class SystemNotificationService {
  private confirmationService = inject(ConfirmationService);


  public show(messageText: string) {
    this.confirmationService.info(messageText, 'Mdd::Title:Notification', {
      hideCancelBtn: true,
      yesText: 'AbpAccount::Close',
    });
  }
}
